export default __webpack_public_path__ + "static/media/logoHeaderRS.d5a0c372.png";